import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Router } from '@angular/router';

@Component({
  selector: 'app-order-invoice-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './order-invoice-form.component.html',
  styleUrl: './order-invoice-form.component.scss'
})
export class OrderInvoiceFormComponent implements OnInit {
  @Input() reload: boolean = false;

  modalTitle: string = 'Bestelling aanmaken';
  modalStyle: boolean = false;

  errorMessage: string = '';
  loading: boolean = false;
  formErrors: any = {};

  @Input() item: any = {
    first_name: '',
    last_name: '',
    email_address: '',
    school_name: '',
    address: '',
    postal_code: '',
    city: '',
    invoice_email: ''
  };

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
    if (this.item.id != undefined) {
      this.modalTitle = "Bestelling wijzigen";
    }
  }

  save() {
    this.loading = true;
    if (this.item.id == undefined) {
      if (!this.validateOrder()) {
        this.errorMessage = 'Alle velden zijn verplicht.';
        return;
      }
  
      this.apiService.post('/office/orders', this.item)
        .then((data: any) => {
          this.loading = false;
          this.activeModal.close(true);

          this.router.navigate(['/orders/details/' + data.id]);
        })
        .catch(() => {
          this.loading = false;
          this.errorMessage = 'Fout bij het aanmaken van de bestelling.';
        });
    } else {
      this.apiService.patch('/office/orders/' + this.item.id, this.item)
      .then(() => {
        this.loading = false;
        this.activeModal.close(true);
      })
      .catch(() => {
        this.loading = false;
        this.errorMessage = 'Fout bij het aanmaken van de bestelling.';
      });
    }
  }

  validateOrder(): boolean {
    if(this.item.id != undefined) {
      delete this.item.order_items;
    }
    return Object.entries(this.item).every(([key, value]: any) => {
      if (key === 'shipping_costs') {
        return true;
      }

      return value && value.toString().trim() !== '';
    });
  }
}
